export default {
  path: '/test-tables/:id',
  component: () =>
    import(
      '@/components/pages/TestTables/TestTable.vue'
    )
}
